
import { Options, prop, Vue } from "vue-class-component";
import ChatBoxMessage from "./chat-box-message.vue";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: ["close", "submit"],
  components: {
    ChatBoxMessage
  }
})
export default class ModalFinishIssue extends Vue.with(Props) {
  mounted() {
    // reset value
    this.resetValue();
  }

  resetValue() {
    PusatResolusiV2Controller.setChatMessageFinish("");
    PusatResolusiV2Controller.setMentionSelectedFinish([]);
    PusatResolusiV2Controller.setUploadedFilesFinish([]);
  }

  get message(): string {
    return PusatResolusiV2Controller.chatMessageFinish;
  }

  set message(val: string) {
    PusatResolusiV2Controller.setChatMessageFinish(val);
  }

  onCloseModal() {
    this.$emit("close");
    this.$emit("update:modelValue", false);
    this.resetValue();
  }

  onSubmitModal() {
    this.$emit("update:modelValue", false);
    this.$emit("submit");
  }
}
